module.exports = __webpack_public_path__ + "img/icon-qrcode-green@3x.43735091.png";